import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AuthState, User } from './types';

const initialState: AuthState = {
  currentUser: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.currentUser = action.payload;
    },
    clearUser: (state) => {
      state.currentUser = null;
    }
  }
});

// Selectors
export const getCurrentUser = (state: { auth: AuthState }) => state.auth.currentUser;

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
